//Константы из SetupView
export default {
  header_title: "Assets",
  header_description: "Select Asset",
  loading: "Loading application...",
  preview: "Preview",
  error: "Error",
  view_not_configured: "View is not configured"
}
